export default "__VITE_ASSET__DISvNIjk__"